import { createApp } from "vue";
import router from "./router";
import store from "./store";
import "./assets/bootstrap.css";
import "./assets/github.css";
import "./assets/simplebar.min.css";
import "./assets/styles.css";
import "./assets/styles_custom.css";

import App from "./App.vue";

createApp(App).use(router).use(store).mount("#app");
